import { Box, Button, Typography, useTheme } from "@mui/material";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";
import { DocumentError } from "src/components/error/error-illustrations/DocumentError";
import { CatError } from "src/components/error/error-illustrations/CatError";

export interface EkpContentErrorProps {
    /**
     * Error message to be displayed when loading page content.
     */
    errorMsg: string;
    /**
     * Image to be displayed when loading page content.
     * Should be passed as a string representing a value of the `EkpErrorImage` enum.
     * Default value is `DOCUMENT`.
     */
    image?: string;
    /**
     * Error code to be displayed when loading page content. Will not be displayed if no value passed.
     */
    errorCode?: string;
    /**
     * Reload button label to be displayed. Button will not be displayed if no value passed.
     */
    reloadButtonMsg?: string;
}

/**
 * Enum values to choose from for displaying the error image.
 */

export enum EkpErrorImg {
    CAT = "CAT",
    DOCUMENT = "DOCUMENT",
}

/**
 * EkpContentError used to notify the user of an error while loading page content.
 */

export const EkpContentError = ({ image = EkpErrorImg.DOCUMENT, errorMsg, errorCode, reloadButtonMsg }: EkpContentErrorProps) => {
    const theme: SenecEkpTheme = useTheme();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={2} width={"fit-content"} m={"auto"}>
            <Box data-testid={"error-img"} width={"fit-content"} m={"auto"}>
                {image == EkpErrorImg.DOCUMENT ? <DocumentError /> : <CatError />}
            </Box>
            <Box pt={3} maxWidth={"411px"}>
                <Typography variant={"h4"} align={"center"} sx={{ paddingBottom: "8px" }}>
                    {errorMsg}
                </Typography>
                {errorCode ? (
                    <Typography variant={"subtitle1"} align={"center"} color={theme.palette.senecSecondary.neutralGray50}>
                        {errorCode}
                    </Typography>
                ) : null}
            </Box>
            {reloadButtonMsg && (
                <Button
                    sx={{ mt: 3 }}
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => window.location.reload()}
                >
                    {reloadButtonMsg}
                </Button>
            )}
        </Box>
    );
};
